import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import Seo from "@/components/seo/Seo";
import { useAuth } from "@/hooks/useAuth";
import { Skeleton } from "@/components/ui/skeleton";
import { ShieldAlert } from "lucide-react";
import AdminSidebar, { AdminMobileTopBar } from "./AdminSidebar";

const ADMIN_ROLES = ["admin", "organizer", "staff"] as const;

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen bg-background items-center justify-center">
      <div className="space-y-4 w-80">
        <Skeleton className="h-8 w-48" />
        <Skeleton className="h-4 w-72" />
        <Skeleton className="h-[200px] w-full" />
      </div>
    </div>
  );
}

function AccessDenied() {
  return (
    <div className="flex min-h-screen bg-background items-center justify-center text-center px-4">
      <div>
        <ShieldAlert className="mx-auto mb-4 text-destructive" size={48} />
        <h1 className="text-xl font-bold mb-2">Acesso Negado</h1>
        <p className="text-muted-foreground text-sm max-w-sm">
          Sua conta não possui permissões para acessar o painel administrativo.
        </p>
      </div>
    </div>
  );
}

export default function AdminHubLayout() {
  const { user, role, loading } = useAuth();
  const [mobileSidebarOpen, setMobileSidebarOpen] = useState(false);

  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/auth" replace />;
  if (!role || !ADMIN_ROLES.includes(role as typeof ADMIN_ROLES[number])) return <AccessDenied />;

  return (
    <div className="flex min-h-screen bg-background">
      <Seo title="Painel Administrativo" description="Área administrativa da FPF3." noindex />
      <AdminSidebar
        mobileOpen={mobileSidebarOpen}
        onMobileClose={() => setMobileSidebarOpen(false)}
      />

      <div className="flex flex-col flex-1 min-w-0 overflow-hidden">
        <AdminMobileTopBar onMenuOpen={() => setMobileSidebarOpen(true)} />

        <main className="flex-1 overflow-y-auto">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
